<div class="modal-header">
  @if (isShowingRecap) {
    <h4 class="modal-title">Récapitulatif de la demande de modification
    de {{ user.firstname }} {{ user.lastname }}</h4>
  }
  @if (!isShowingRecap) {
    <h4 class="modal-title">Demande de modification
    de {{ user.firstname }} {{ user.lastname }}</h4>
  }
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div [hidden]="isShowingRecap">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" [destroyOnHide]="false" class="nav-tabs">
      <li [ngbNavItem]="1">
        <button ngbNavLink>Logiciels</button>
        <ng-template ngbNavContent>
          <app-users-edit-modal-products-list [(addProductMode)]="addProductMode" [parentForm]="form"
          [user]="user"></app-users-edit-modal-products-list>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <button ngbNavLink>Profil</button>
        <ng-template ngbNavContent>
          <div class="alert alert-info">
            <fa-icon icon="info-circle"></fa-icon>
            {{ user.firstname }} {{ user.lastname }} est un
            utilisateur {{ user.referent ? 'référent Portail' : 'simple' }}
          </div>
          <app-user-profile-form [parentForm]="form" [user]="user" [profileOnly]="true"
          formName="profile"></app-user-profile-form>
        </ng-template>
      </li>
      <li [ngbNavItem]="3">
        <button ngbNavLink>Coordonnées</button>
        <ng-template ngbNavContent>
          <app-user-coords-form [user]="user" [parentForm]="form" formName="coords"></app-user-coords-form>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-3"></div>
  </div>
  <div [hidden]="!isShowingRecap">
    @if (isShowingRecap) {
      <app-user-request-comparator
        [user]="user"
        [request]="getCleanedRequest()">
      </app-user-request-comparator>
    }

    @if(isShowingRecap) {
      @if(isChangingUser()) {
        <div class="alert alert-danger">
          Attention, il n'est pas possible de remplacer un utilisateur par un autre via ce formulaire.
          Pour ajouter un utilisateur, merci de passer par
          <a routerLink="utilisateurs/nouveau">ce formulaire d'ajout</a>.
          Pour toute autre demande, vous pouvez envoyer une demande par mail à :
          <a href="mailto:contact.portail@libriciel.fr">contact.portail&#64;libriciel.fr</a>
        </div>
      } @else {
        <div class="alert alert-warning">
          <fa-icon icon="info-circle"></fa-icon>
          Votre demande sera traitée dans les meilleurs délais.
        </div>
        <app-user-infos-form formName="infos" [onlyRgpd]="true" [parentForm]="form">
        </app-user-infos-form>
      }
    }
  </div>
</div>
<div class="modal-footer justify-content-between justify-content-md-end">
  <div>
    @if (isShowingRecap) {
      <button class="btn btn-outline-info" (click)="hideRecap()">
        <fa-icon icon="arrow-left"></fa-icon>
        Retour
      </button>
    }
  </div>
  <app-cancel-button class="d-none d-md-inline" (click)="activeModal.dismiss()"></app-cancel-button>
  @if (isShowingRecap) {
    <button type="submit" class="btn btn-primary" [disabled]="isChangingUser() || (form && form.invalid) || !form.get('infos').value['rgpd']"
      (click)="sendRequest()">
      <fa-icon icon="paper-plane" class="d-none d-md-inline-block"></fa-icon>&nbsp;Envoyer
      <span class="d-none d-md-inline"> ma demande</span>
    </button>
  }
  @if (!isShowingRecap) {
    <div [disableTooltip]="!addProductMode"
      ngbTooltip="Une confirmation d'ajout de logiciel est en attente">
      <button type="submit" class="btn btn-primary" [disabled]="canNotSendRequest" (click)="showRecap()">
        <fa-icon icon="check" class="d-none d-md-inline-block"></fa-icon>&nbsp;Valider
        <span class="d-none d-md-inline"> ma demande</span>
      </button>
    </div>
  }
</div>
